/**
 * @generated SignedSource<<36747fbc3136f450659bf999b4e67c62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutineOverviewListItemExpireText_routineOccasion$data = {
  readonly expireAt: string;
  readonly startAt: string;
  readonly status: RoutineOccasionStatus;
  readonly " $fragmentType": "WidgetRoutineOverviewListItemExpireText_routineOccasion";
};
export type WidgetRoutineOverviewListItemExpireText_routineOccasion$key = {
  readonly " $data"?: WidgetRoutineOverviewListItemExpireText_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewListItemExpireText_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetRoutineOverviewListItemExpireText_routineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "calculateNoTasks",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "calculateNotCompletedStarted",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "status",
      "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "5d07f7033d95d7e457d2200cb785fdc4";

export default node;
